import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavButtonComponent {
  /** The button text (optional) */
  label = input<string | null>(null);

  /** The icon name to display (optional) */
  iconName = input<string | undefined>(undefined);

  /** The HTML button type attribute (optional, default: 'button') */
  buttonType = input<'button' | 'submit' | 'reset'>('button');

  /** ID for the button element (optional) */
  buttonId = input<string | undefined>(undefined);

  /** Whether the button is disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Whether to display the text label (optional, default: false) */
  displayText = input<boolean>(false);

  /** Event emitted when the button is clicked */
  buttonClicked = output<void>();

  /** Computed CSS classes for the button */
  classes = computed(() => {
    const disabled = this.isDisabled() ? 'disabled' : '';
    const hasText =
      this.label() && this.displayText() ? 'icon-button--text' : '';
    return `icon-button ${hasText} ${disabled}`.trim();
  });

  /** Handles the button click and emits the output event */
  clickButton = (): void => {
    this.buttonClicked.emit();
  };
}
